import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RestAssistanceService} from '@app/core/api/assistance.service';
import {ActiveAssistanceQuery} from '@app/core/state/active-assistance/active-assistance.query';
import {ActiveAssistanceStore} from '@app/core/state/active-assistance/active-assistance.store';
import {PayloadUtil} from '@app/core/util/payload.util';
import {AssistancePerson, AssistancePolizze} from '@pezi/entities';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class ActiveAssistanceService {

  private assistanceSubscription: Subscription;
  private polizzeSubscription: Subscription;

  constructor(private activeAssistanceStore: ActiveAssistanceStore, private activeAssistanceQuery: ActiveAssistanceQuery,
              private assistanceService: RestAssistanceService, private snackBar: MatSnackBar) {
  }

  public initAssistance(personId: number) {
    if (this.assistanceSubscription) {
      this.assistanceSubscription.unsubscribe();
      this.activeAssistanceStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activeAssistanceStore.data.getValue();
    if (!personId) {
      this.clearStore();
    } else {
      if (!currentState.person || !currentState.person.personResult || currentState.person.personResult.id !== +personId) {

        this.activeAssistanceStore.data.reset();
        this.activeAssistanceStore.data.update(setProps({
          loading: true
        }));
        this.assistanceSubscription = this.assistanceService.getPersonForId(personId)
          .pipe(
            take(1)
          )
          .subscribe(result => {
            let pers: AssistancePerson;
            let errorLoadingAssistance = false;
            if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
              'Fehler: Informationen konnten nicht geladen werden')) {
              pers = result.data;
            } else {
              errorLoadingAssistance = true;
            }
            this.activeAssistanceStore.data.update(setProps({
              loading: false,
              errorLoading: errorLoadingAssistance,
              person: pers
            }));
          });
      }
    }
  }

  public initPolizze(polizzeId: number, personId: number) {
    if (this.polizzeSubscription) {
      this.polizzeSubscription.unsubscribe();
      this.activeAssistanceStore.data.update(setProps({
        loadingPolizze: false
      }));
    }
    const currentState = this.activeAssistanceStore.data.getValue();
    if (!polizzeId) {
      this.clearPoliceStore();
    } else {
      if (!currentState.polizzeWithId || !currentState.polizzeWithId.polizze || currentState.polizzeWithId.polizze.id !== +polizzeId) {

        this.clearPoliceStore();
        this.activeAssistanceStore.data.update(setProps({
          loadingPolizze: true
        }));
        this.polizzeSubscription = this.assistanceService.getPolizze(polizzeId)
          .pipe(
            take(1)
          )
          .subscribe(result => {
            let pol: AssistancePolizze;
            let errorLoadingAssistance = false;
            if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
              'Fehler: Informationen konnten nicht geladen werden')) {
              pol = result.data;
            } else {
              errorLoadingAssistance = true;
            }
            this.activeAssistanceStore.data.update(setProps({
              loadingPolizze: false,
              errorLoadingPolizze: errorLoadingAssistance,
              polizzeWithId: {
                persId: personId,
                polizze: pol
              }
            }));
          });
      }
    }
  }

  clearStore() {
    this.activeAssistanceStore.data.reset();
  }

  clearPoliceStore() {
    this.activeAssistanceStore.data.update(setProps({
      loadingPolizze: false,
      errorLoadingPolizze: false,
      polizzeWithId: undefined
    }));
  }
}
